import { useCallback } from 'react';

import { useStoreAvailabilityFns } from 'features/store/hooks/use-store-availability-fns';

import { IRestaurant } from '@rbi-ctg/store';

import { IStoreDiagnostics } from '../types';
import { getAvailableDayParts } from '../utils';

export const useStoreDiagnostics = () => {
  const {
    isStoreAvailableForPickup,
    isStoreAvailableForDelivery,
    getStoreServiceModeStatuses,
    isMobileOrderingAvailable,
    isPOSAvailable,
  } = useStoreAvailabilityFns();

  return useCallback(
    (store: IRestaurant): IStoreDiagnostics | undefined => {
      const availableDayParts = getAvailableDayParts(store);
      return {
        storeName: store.name || '',
        storeCountry: store?.physicalAddress?.country || '',
        storeStreetAddress: store?.physicalAddress?.address1 || '',
        storeId: store.storeId,
        storePosVendor: store.pos?.vendor,

        storeLocalTime: store.localTime,
        storeServiceModeHours: store.serviceModeHours,
        storeDayPartHours: store.dayPartHours,
        storeAvailableDayParts: availableDayParts?.map(dp => dp.key).join(','),

        storeHasMobileOrdering: Boolean(store.hasMobileOrdering),
        storeMobileOrderingStatus: store.mobileOrderingStatus,
        storeServiceModeStatuses: getStoreServiceModeStatuses(store),
        isStoreAvailableForPickup: isStoreAvailableForPickup(store),
        isStoreAvailableForDelivery: isStoreAvailableForDelivery(store),
        isMobileOrderingAvailable: isMobileOrderingAvailable(store),
        isPOSAvailable: isPOSAvailable(store),
      };
    },
    [
      getStoreServiceModeStatuses,
      isMobileOrderingAvailable,
      isPOSAvailable,
      isStoreAvailableForDelivery,
      isStoreAvailableForPickup,
    ]
  );
};
